module.exports = __webpack_public_path__ + "static/media/watch-movie.f4cc4cc4.wav";